<template>
  <BaseModal
    name="refuelingVehicleModalSingle"
    width="420"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="closeModalAndClearData"
    :adaptive="true"
    height="auto"
    classes="!tw-bg-transparent !tw-shadow-none"
  >
    <div
      v-if="stateLoading"
      class="position-absolute wp-100 h-100 d-flex justify-content-center align-items-center bg-white"
      style="top: 0; left: 0; z-index: 500"
    >
      <svg class="spinner" viewBox="0 0 50 50">
        <circle
          class="path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke-width="5"
        ></circle>
      </svg>
    </div>

    <div
      class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
    >
      <button
        type="button"
        class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
        @click="$modal.hide('refuelingVehicleModalSingle')"
      ></button>

      <div>
        <div class="tw-text-center tw-text-[23px] tw-mb-[15px]">
          {{ dataLang["vehicle_modal_service_modals_title_5"] }}
        </div>

        <div class="tw-mb-[15px]" ref="vehicle_services__price">
          <div class="tw-app-input-type-3-label">Стоимость (спишется с ТФ)</div>
          <BaseInputNew
            inputClass="tw-app-input-type-3"
            input-name="vehicle_services__price"
            @input="updateValue"
            :value="dataForEmit.vehicle_services__price"
          >
          </BaseInputNew>
        </div>

        <div
          class="tw-text-center tw-bg-[#F5F5F5] tw-py-[10px] tw-px-[15px] tw-text-forTitle tw-text-[14px] tw-font-bold tw-mb-[10px] tw-rounded-[3px]"
        >
          {{ dataLang["vehicle_modal_service_modals_warning1"] }}
        </div>

        <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
          <button
            @click="$modal.hide('refuelingVehicleModalSingle')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            {{ dataLang["vehile_modal_btn_reset"] }}
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
            :disabled="submitting"
          >
            {{ dataLang["vehile_modal_btn_save"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { Modal } from "bootstrap";
import { mapActions, mapState, mapMutations } from "vuex";
import ObjectService from "@/api/ObjectsService.js";
import EventBus from "@/event-bus.js";
// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  props: {
    nameForAction: {
      type: String,
    },
    modalName: {},
    centered: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
    },
    size: {
      type: String,
      default: "",
    },
    minHeight: {
      type: Number,
    },
    stateLoading: {
      type: Boolean,
      default: false,
    },
    optionalParams: {
      type: Object,
    },
  },
  data() {
    return {
      submitting: false,
      thisModal: null,
      dataForEmit: {
        vehicle_services__service_type_id: 5,
        //   vehicles__odometr: null,
        vehicle_services__price: null,
        //   payed_to: '',
        //   vehicle_services__text: '',
        // interval: null,
      },
    };
  },
  methods: {
    updateValue(data) {
      this.dataForEmit[data.name] = data.value;
      this.$refs[data.name].classList.remove("input-error");
    },

    sendData() {
      this.submitting = true;
      ObjectService.createService(this.optionalParams.id, this.dataForEmit)
        .then((data) => {
          this.closeModalAndClearData();
          this.$toast.success("Запись добавлена");
          this.submitting = false;
          Object.keys(this.dataForEmit).forEach((elem, index) => {
            if (this.$refs[elem]) {
              this.$refs[elem].classList.remove("input-error");
            }
          });
          this.$modal.hide("refuelingVehicleModalSingle");
          EventBus.$emit("contentLoaded");
          EventBus.$emit("updateContentData");
        })
        .catch((err) => {
          this.submitting = false;
          this.$toast.error(err.response.data.message, { duration: 5000 });
          Object.keys(err.response.data.errors).forEach((elem, index) => {
            if (this.$refs[elem]) {
              this.$refs[elem].classList.add("input-error");
            }
          });
        });
    },

    closeModalAndClearData() {
      this.dataForEmit.vehicles__odometr = null;
      this.dataForEmit.vehicle_services__price = null;
      this.dataForEmit.payed_to = "";
      this.dataForEmit.vehicle_services__text = "";
      this.dataForEmit.interval = null;
    },
  },

  computed: {
    ...mapState("modalStackModule", ["modalStackPosition"]),
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
